import React from 'react'

function LinkItem({name,To,handleFunc}) {
  return (
    <div className="transition ease-in-out delay-50 hover:-translate-y-1 hover:scale-105 mx-3 my-2 cursor-pointer hover:text-[#496c62]" onClick={()=>handleFunc(To)} >{name}</div>
  )
}

export default LinkItem;